import { render, staticRenderFns } from "./Exclusive.vue?vue&type=template&id=c2720726&"
import script from "./Exclusive.vue?vue&type=script&lang=js&"
export * from "./Exclusive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports